import React from "react";
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useAuthStore } from "stores/authStore/authStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import {
  LoggedInPageContainer,
  LoggedOutPageContainer,
} from "components/pageLayouts/pageLayouts.styled";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import { Gigs } from "web-apps/company/components/gig/gigList/gigs.component";

export const GigPage: React.FC<{}> = () => {
  const { t } = useTranslation();

  const [authState] = useAuthStore();
  const [companyState] = useCompanyStore();

  return (
    <>
      {authState.isLoading ? (
        <LoggedOutPageContainer>
          <CircularProgress />
        </LoggedOutPageContainer>
      ) : (
        <LoggedInPageContainer>
          {companyState.company?.verified ? (
            <Gigs />
          ) : (
            <BannerComponent
              icon="clock"
              backgroundColor={Color.ChampagnePink}
              fill={Color.Destructive}
            >
              <Text
                fontSize={FontSize.Large}
                fontFamily={FontFamily.MontserratSemiBold}
                color={Color.Destructive}
              >
                {t("GigsCompany.UnverifiedAccount")}
              </Text>
              <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
            </BannerComponent>
          )}
        </LoggedInPageContainer>
      )}
    </>
  );
};
